import { on, popup } from '@telegram-apps/sdk-react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const useDisconnectWallet = (onDisconnectConfirmed: () => void) => {
  const { t } = useTranslation();

  useEffect(() => {
    const handlePopupClosed = (payload: { button_id: string }) => {
      if (payload.button_id === 'disconnect') {
        onDisconnectConfirmed();
      }
    };

    // eslint-disable-next-line
    // @ts-ignore
    on('popup_closed', handlePopupClosed);

    return () => {
      // eslint-disable-next-line
      // @ts-ignore
      on('popup_closed', handlePopupClosed);
    };
  }, []);

  return async () => {
    await popup.show({
      title: t('earn.disconnect_wallet_confirm_popup_title'),
      message: t('earn.disconnect_wallet_confirm_popup_subtitle'),
      buttons: [
        {
          id: 'disconnect',
          type: 'destructive',
          text: t('earn.disconnect')
        },
        {
          id: 'cancel',
          type: 'default',
          text: t('cancel_title')
        }
      ]
    });
  };
};
